import { type FilterData } from '@itinerary/ItineraryModuleTypes';

export enum BusFilters {
    Price = 'price',
    Time = 'time',
    BusType = 'type',
    Carrier = 'carrier',
}

export interface IDNamePair {
    id: number;
    name: string;
}

export interface BusFilterData extends FilterData {
    corporations: IDNamePair[];
    maxPrice: number;
    minPrice: number;
    fromTerminals: IDNamePair[];
    toTerminals: IDNamePair[];
}

export interface BusFiltersData {
    key: BusFilters;
    meta: BusFilterData;
}
